import {
  Button,
  Inline,
  Modal,
  type ModalProps,
  Notification,
  notifySuccess,
} from '@omnipresentgroup/design-system';
import { useEmploymentMutation } from '@omnipresentgroup/domains';
import { toSentenceCase } from '@omnipresentgroup/helpers';
import {
  type Employment,
  type EmploymentStatus,
  EmploymentStatusMap,
} from '@omnipresentgroup/types';

type Props = {
  modalProps: Omit<ModalProps, 'children'>;
  employment: Employment;
  status: EmploymentStatus;
  handleCancel: () => void;
  handleSuccess: () => void;
};

export const ChangeEmploymentStatusModal = ({
  modalProps,
  employment,
  status,
  handleCancel,
  handleSuccess,
}: Props) => {
  const { mutate: updateEmployment, isPending: isUpdatingEmployment } =
    useEmploymentMutation({
      id: employment.id,
      onSuccess: () => {
        notifySuccess({
          title: 'Employment has been updated successfully',
        });
        handleSuccess();
      },
    });

  return (
    <Modal {...modalProps} span={4}>
      <Modal.Header
        title={'Change employment status'}
        description={`Id: ${employment.id}`}
      />
      <Modal.Body>
        <Notification
          id={`change-employment-status-notice-${employment.id}`}
          intent="warning"
          title={`Are you certain you want to change the status of this employment to ${toSentenceCase(
            EmploymentStatusMap[status],
          ).toLowerCase()}?`}
        />
      </Modal.Body>
      <Modal.Footer>
        <Inline justify="space-between" w="stretch">
          <Button
            variant="secondary"
            onClick={handleCancel}
            disabled={isUpdatingEmployment}
          >
            Cancel
          </Button>
          <Button
            onClick={() =>
              updateEmployment({
                status,
              })
            }
            loading={isUpdatingEmployment}
          >
            Update
          </Button>
        </Inline>
      </Modal.Footer>
    </Modal>
  );
};
